import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClone, faCircleNotch, faHeadset } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import Checkbox from '@mui/material/Checkbox';
import Bar from "../components/chart/Bar";
import { useLocation } from 'react-router-dom';
import { getCurrencySymbol, formatCurrency, getRate } from '../utils/currencyUtils';
import { toast } from 'react-hot-toast';
const label = { inputProps: { 'aria-label': 'Checkbox' } };

function LoanSummary() {
  const { user } = useUser();
  const { state } = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
    const r = await getRate(currencyCode);
    if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const [loanDetails, setLoanDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loading1, setLoading1] = useState(false);
  const [disable, setDisable] = useState(true);
  useEffect(() => {
    if (!state) return;
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchsoffer: true, loan_id:state.loan_id })
    })
    .then(response => response.json()) 
    .then(data => {
        setLoanDetails(data.offer);
        setLoading(false);
    })
    .catch(err => {
        window.location.href = '/loan';
    })
  }, [state]);
  const [loanData, setLoanData] = useState([]);
  //FORM DATA//
  //FORM DATA//
  //FORM DATA//
  const [isChecked, setIsChecked] = useState(false);
  useEffect(() => {
    if(isChecked){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [isChecked]);
  const getLoan = () =>{
    const rate = (state.ltv/convertToDays(loanDetails.period, loanDetails.duration) * loanDetails.rate).toFixed(2);
    setLoading1(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/loan.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
        "Content-Type": "application/json"
        },
        body: JSON.stringify({ btn_loan: true, loan_id: state.loan_id, casset: state.casset, collateral: state.collateral, loanasset : state.loanasset, loan : state.loan, rate : rate, duration : state.ltv, cprice : state.cprice, price : state.price })
    })
    .then(response => response.json())
    .then(data => {
        if (data.status === "success") {
            setLoading1(false);
            toast.success(data.result);
            setTimeout(() => {
                window.location.href = "loan";
            }, 2000);
        }else{
            toast.error(data.message);
            setLoading1(false);
        }
    })
    .catch(err => {
        console.error(err)
        setLoading1(false);
    })
  }
  //FORM DATA//
  //FORM DATA//
  //FORM DATA//
  const [assethistory, setAssethistory] = useState([]);
  const [crypto, setCrypto] = useState([]);
  const [fiat, setFiat] = useState([]);
  const [stock, setStock] = useState([]);
  const [wallet, setWallet] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchwallet: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setWallet(data.wallet);
      }
    })
    .catch(err => {
      
    })
  }, [user]);
  useEffect(() => {
      fetch(`/coin_list.txt`)
      .then((res) => res.json())
      .then((data) => {
      var coinList = data.data;
      const updatedData = coinList.map((coin, index) => ({
          id: index + 1,
          logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
          name: coin.name,
          type: 'crypto',
          symbol: coin.symbol,
          price: Number(coin.quote.USD.price.toFixed(2)),
          amount: 0,
      }));
      setCrypto(updatedData);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    fetch(`/stock_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    const stockList = Object.values(data);
    const updatedData = stockList.map((stock, index) => ({
        id: index + 1,
        logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
        name: stock.name,
        type: 'stock',
        symbol: stock.symbol,
        price: Number(stock.price.toFixed(2)),
        amount: 0,
    }));
    setStock(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {   
      fetch(`/fiat_list.txt`)
      .then((res) => res.json())
      .then((data) => {
        const wantedCurrencies = {
          AUD: 'Australian Dollar',
          CAD: 'Canadian Dollar',
          CHF: 'Swiss Franc',
          CNY: 'Chinese Yuan',
          EUR: 'Euro',
          GBP: 'British Pound',
          INR: 'Indian Rupee',
          JPY: 'Japanese Yen',
          RUB: 'Russian Ruble',
          USD: 'US Dollar',
          ZAR: 'South African Rand'
        };
        const fiatList = Object.entries(data)
          .filter(([code]) => wantedCurrencies.hasOwnProperty(code))
          .map(([code, value], index) => ({
            id: index + 1,
            symbol: code,
            name: wantedCurrencies[code],
            price: Number(value),
            type: 'fiat',
            logo: `https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`,
            amount: 0,
          }));
        
        setFiat(fiatList);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    if (!crypto.length && !fiat.length && !stock.length) return;
    const walletMap = wallet.reduce((acc, item) => {
      const key = item.coinName?.trim().toLowerCase();
      acc[key] = parseFloat(item.balance) || 0;
      return acc;
    }, {});
    const applyWalletBalance = (list, categoryTotal) => {
      let categorySum = 0;
      const result = list.map(item => {
        const key = item.name?.trim().toLowerCase();
        const matchedBalance = walletMap[key];
        const amount = matchedBalance || 0;
        const value = amount * item.price;
        categorySum += value;
        return {
          ...item,
          amount: matchedBalance || 0
        };
      });
      return { result, categorySum };
    };
    const { result: cryptoWithBalance } = applyWalletBalance(crypto);
    const { result: fiatWithBalance } = applyWalletBalance(fiat);
    const { result: stockWithBalance } = applyWalletBalance(stock);
    const merged = [
      ...cryptoWithBalance,
      ...fiatWithBalance,
      ...stockWithBalance
    ];
    const sorted = merged.sort((a, b) => {
      if (b.amount > 0 && a.amount === 0) return 1;
      if (a.amount > 0 && b.amount === 0) return -1;
      return a.name.localeCompare(b.name);
    });
    const allAssets = [];
    sorted.forEach(coin => {
      allAssets.push({
        value: coin.name,
        label: <><img src={coin.logo} alt={coin.symbol} width="20" /> {coin.symbol}</>,
        id: coin.id,
        logo: coin.logo,
        name: coin.name,
        symbol: coin.symbol,
        type: coin.type,
        price: coin.price,
        amount: coin.amount
      });
    });
    setAssethistory(allAssets);
  }, [crypto, fiat, stock, wallet]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchloan: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setLoanData(data.countedloan);
      }
    })
    .catch(err => {
    })
  }, [user]);
  const [chartData, setChartData] = useState({
    labels: [],
    data: []
  });
  const processLoanDataByMonth = (loans) => {
    const monthlyData = {};
    loans.forEach(loan => {
      const loanDate = new Date(loan.date);
      const monthKey = `${loanDate.getFullYear()}-${String(loanDate.getMonth() + 1).padStart(2, '0')}`;
      if (!monthlyData[monthKey]) {
        monthlyData[monthKey] = 0;
      }
      const asset = assethistory.find(asset => asset.name === loan.method);
      let price = 1;
      if (asset) {
        price = asset.price;
      }
      monthlyData[monthKey] += ((parseFloat(loan.amount.replace(/,/g, '')) * price) * rate).toFixed(2);
    });
    const labels = [];
    const data = [];
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - 7);
    for (let i = 0; i < 8; i++) {
      const monthKey = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}`;
      labels.push(formatMonth(currentDate));
      data.push(monthlyData[monthKey] ? Number(monthlyData[monthKey]).toFixed(2) || 0 : 0);
      currentDate.setMonth(currentDate.getMonth() + 1);
    }
    return { labels, data };
  };
  const formatMonth = (date) => {
    const options = { month: 'short' };
    return new Intl.DateTimeFormat('en-US', options).format(date);
  };
  useEffect(() => {
    const { labels, data } = processLoanDataByMonth(loanData);
    setChartData({ labels, data });
  }, [loanData]);
  const convertToDays = (period, qty) => {
    const map = { y: 356, m: 30, w: 7, d: 1 };
    const base = map[String(period)] || 'Year';
    return (qty * base);
  };

  if(!state &&(!loanDetails ||(Array.isArray(loanDetails) && loanDetails.length === 0))){
    setLoading(false);
  }

  if (loading) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Loan" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Loan" icon={<FontAwesomeIcon icon={faClone} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row">
              <div className="col-lg-6"> 
                <div className="mycard mt-2 d-flex align-items-center">
                  <div className="rounded-circle overflow-hidden d-flex align-items-center justify-content-center" style={{height:'75px',width:'75px'}}>
                    <img src={`/uploads/${loanDetails.photo}`} alt="profile" className="w-100 h-100" style={{objectFit: 'cover'}}/>
                  </div>
                  <div className="ms-3">
                    <p className="fw-bold text-white fw-bold mb-0 text-uppercase">{loanDetails.title}</p>
                    <p className="text-secondary fw-semibold mb-0" style={{fontSize:'14px'}}>Rate: {loanDetails.rate}%</p>
                    <p className="text-secondary fw-semibold mb-0" style={{fontSize:'14px'}}>Range: {getCurrencySymbol(user?.currency)}{formatCurrency(loanDetails.min * rate)} - {getCurrencySymbol(user?.currency)}{formatCurrency(loanDetails.max * rate)}</p>
                  </div>
                </div>
                <div className="mycard shadow p-3 mt-2 position-relative d-none d-md-block" style={{border:'1px solid #ffffff17'}}>
                    <div style={{width:'70%'}}>
                        <h4 className="mb-4 fw-bold">Looking to Finance Your Next Move?</h4>
                        <p className="text-secondary mb-4">Explore flexible home and personal loan options tailored to your needs—competitive rates, clear terms, and fast approvals.</p>
                        <h4 className="mb-0 fw-bold">Need Help?</h4>
                        <p className="mb-0 text-prime mt-2" style={{fontSize:'14px'}}><FontAwesomeIcon className="text-prime me-1" icon={faHeadset} /> Contact our Support</p>
                    </div>
                    <img src="./uploads/partner.png" alt="image" className="position-absolute" style={{width:'25%', bottom:'10px', right:'20px'}}/>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mycard mt-2">
                    <h4 className="mb-0 fw-bold mt-4 mt-lg-0">Loan Summary</h4>
                    <div className="row">
                    <div className="col-xxl-4 col-6 g-4">
                        <div className="pe-4" style={{borderRight: '1px solid gray'}}>
                        <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Loan duration</p>
                        <h4 className="mb-0 fw-bold">{state.ltv} days</h4>
                        <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Loan fee payment required every {state.ltv} days to keep loan open</p>
                        </div>
                    </div>
                    <div className="col-xxl-4 col-6 g-4">
                        <div className="px-lg-4" style={{borderRight: '1px solid gray'}}>
                        <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Loan percentage</p>
                        <h4 className="mb-0 fw-bold">{(state.ltv/convertToDays(loanDetails.period, loanDetails.duration) * loanDetails.rate).toFixed(2)}%</h4>
                        <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>This shows the effective loan rate for the selected duration. You can reduce risk or extend terms by adding more state.collateral at any time.</p>
                        </div>
                    </div>
                    <div className="col-xxl-4 col-6 g-4"> 
                        <div className="px-xxl-4">
                        <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Loan repayment</p>
                        <h4 className="mb-0 fw-bold">{formatCurrency((state.loanUsd + (((state.ltv/convertToDays(loanDetails.period, loanDetails.duration) * loanDetails.rate) / 100) * state.loanUsd)) * rate)} <span className="text-secondary ms-1 fw-normal" style={{fontSize:'14px'}}>{user?.currency}</span></h4>
                        <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Including {(state.loanUsd ? (((state.ltv/convertToDays(loanDetails.period, loanDetails.duration) * loanDetails.rate) / 100) * state.loanUsd) : 0).toFixed(2)} ({(state.ltv/convertToDays(loanDetails.period, loanDetails.duration) * loanDetails.rate).toFixed(2)}%) loan fee. Loan repayment required only for full state.collateral return</p>
                        </div>
                    </div>
                    </div>
                    <div className="mt-2 d-flex align-items-center">
                    <Checkbox
                        {...label}
                        checked={isChecked}
                        onChange={(e) => setIsChecked(e.target.checked)}
                    />
                    <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>I have read and agree to the <span className="text-prime">Terms & Conditions</span></p>
                    </div>
                    <div className="mt-2 pt-3 d-flex justify-content-between align-items-end">
                        <div>
                            <h3 className="mb-0 fw-bold">{formatCurrency((state.loanUsd ? state.loanUsd : 0) * rate)} <span className="text-secondary ms-1 fw-normal" style={{fontSize:'14px'}}>{user?.currency} Loan</span></h3>
                            <p className="text-secondary mt-2 mb-0" style={{fontSize:'14px'}}>For {Number(state.collateral ? state.collateral : 0).toFixed(6)} {state.collat} Equity</p>
                        </div>
                        <div className={`myBtn px-4 py-3 me-2 mt-3 d-inline-block fw-semibold ${disable?'disabled':null}`} style={{textDecoration:'none', cursor:'pointer', fontSize:'14px'}} onClick={!disable ? getLoan : null}>{loading1?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'GET LOAN'}</div>
                    </div>
                </div>
              </div>
              <div claName="col-12">
                <div className="mycard mt-2">
                  <h5 className="fw-bold">Loan History ({user?.currency})</h5>
                  <Bar label={chartData.labels} data={chartData.data}/>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default LoanSummary